import axios from "axios";
import { Toast } from "../../util/Toast";
import {
  GET_LEVEL_UP_REWARDS,
  EDIT_LEVEL_UP_REWARD,
  CLOSE_LEVEL_UP_REWARD_DIALOG,
  ADD_LEVEL_UP_REWARD,
  DELETE_LEVEL_UP_REWARD,
} from "./types";

export const getLevelUpRewards = () => (dispatch) => {
  axios
    .get(`levelUpReward`)
    .then((res) => {
      console.log("levelUpReward", res.data);
      if (res.data.status) {
        dispatch({ type: GET_LEVEL_UP_REWARDS, payload: res.data.data });
      } else {
        Toast("error", res.data.message);
      }
    })
    .catch((error) => Toast("error", error.message));
};

export const deleteLevelUpReward = (data) => (dispatch) => {
  axios
    .delete(`levelUpReward/reward`, { data })
    .then((res) => {
      console.log("deleteLevelUpReward", res.data);
      if (res.data.status) {
        dispatch({
          type: DELETE_LEVEL_UP_REWARD,
          payload: res.data.data,
        });
      } else {
        Toast("error", res.data.message);
      }
    })
    .catch((error) => Toast("error", error.message));
};

export const addLevelUpReward = (data) => (dispatch) => {
  axios
    .post(`levelUpReward/reward`, data)
    .then((res) => {
      if (res.data.status) {
        console.log("addLevelUpReward", res.data.data);
        dispatch({
          type: ADD_LEVEL_UP_REWARD,
          payload: res.data.data,
        });
        dispatch({
          type: CLOSE_LEVEL_UP_REWARD_DIALOG
        });
      } else {
        Toast("error", res.data.message);
      }
    })
    .catch((error) => Toast("error", error.message));
};

export const editLevelUpReward = (levelId, data) => (dispatch) => {
  axios
    .patch(`levelUpReward/${levelId}`, data)
    .then((res) => {
      if (res.data.status) {
        Toast("success", "Level updated successfully!");
        dispatch({ type: CLOSE_LEVEL_UP_REWARD_DIALOG });
        dispatch({
          type: EDIT_LEVEL_UP_REWARD,
          payload: { data: res.data.level, id: levelId },
        });
      } else {
        Toast("error", res.data.message);
      }
    })
    .catch((error) => Toast("error", error.message));
};